export default "__VITE_ASSET__N5ff8E2S__"